import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseTypes as paramPurchaseTypes } from '../../utils/routeParamConstants';
import { ShopTabs } from './Constants';
import { KYC_STATUS } from '../../utils/kyc/Constants';
import Screens from '../index';
import { casinoIdStatus as PlayerStatus } from '../../api/PlayerInfoConstants';
import UpgradeType from '../UpgradeAccountFlow/UpgradeType';
import { isStar } from '../../utils/targetApplication';
export default function buyClickedHandler(sku, name) {
  var _queryParams;

  var dynamicTriggeredSaleId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (this.props.isKYCDone && this.props.KYCResult === KYC_STATUS.FAILED) {
    QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.KYCLockout));
    return;
  }

  var purchaseType = paramPurchaseTypes.CURRENCY;

  if (this.state && this.state.shopTab === ShopTabs.VIP) {
    purchaseType = paramPurchaseTypes.VIP;
  }

  this.props.setPurchaseType(purchaseType);
  this.props.setAuthCallbackPurchaseData({
    purchaseType: purchaseType,
    sku: sku,
    name: name
  });
  var casinoIdStatus = this.props.casinoIdStatus;
  var queryParams = (_queryParams = {}, _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_SKU, sku), _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_TYPE, purchaseType), _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_NAME, name), _queryParams);

  if (Utils.getPlatform() === 'web') {
    queryParams[RouteParamConstants.PARAM_MODAL] = isStar ? Screens.CurrencySelector : Screens.PurchaseFlow;
  }

  if (dynamicTriggeredSaleId > 0) {
    queryParams[RouteParamConstants.PARAM_PURCHASE_DTS_ID] = dynamicTriggeredSaleId;
  }

  switch (casinoIdStatus) {
    case PlayerStatus.PHYSICALLY_VERIFIED:
    case PlayerStatus.DIGITALLY_VERIFIED:
      this.props.initiatePurchase();
      break;

    case PlayerStatus.UNVERIFIED:
    case PlayerStatus.GUEST:
    case PlayerStatus.FACEBOOK:
    case PlayerStatus.GOOGLE:
    case PlayerStatus.APPLE:
      if (isStar && Utils.getPlatform() === 'web') {
        queryParams[RouteParamConstants.PARAM_MODAL] = Screens.UpgradeAccountFlow;
        queryParams[RouteParamConstants.PARAM_NAVIGATE_TO] = Screens.PurchaseFlow;
        queryParams[RouteParamConstants.PARAM_UPGRADE_TYPE] = UpgradeType.COMBINED;
      } else {
        this.props.initiatePurchase();
      }

      break;

    default:
      !isStar ? this.props.initiatePurchase() : console.error("Unexpected casinoIdStatus: ".concat(casinoIdStatus));
  }

  QueryParamsProxy.setQueryParams(queryParams);
}